import { ZipReducerDispatch, ZipReduxState, ZipReduxTypes } from "./types";

const ZIP_LOOKUP_INIT_STATE = {
  data: {},
  loading: false,
  error: null,
  zip: ""
};

const ZipLookupReducer = (state: ZipReduxState = ZIP_LOOKUP_INIT_STATE, action: ZipReducerDispatch) => {
  switch (action.type) {
    case ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        zip: action.payload.data?.zip,
        loading: false,
        error: null
      };
    }
    case ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        zip: action.payload.zip,
        loading: false
      };
    }
    case ZipReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: null,
        zip: ""
      };
    default:
      return { ...state };
  }
};

export { ZipLookupReducer };
